import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { emailPattern } from './validationUtils';
import { format, isWithinInterval, parse, startOfTomorrow } from 'date-fns';
import { GetCurrentDate } from 'src/packages/lci/constants/LCIConstant';
export const usernameRegex = /^[a-zA-Z0-9_.+\-]{4,127}[a-zA-Z0-9_+\-]$/;
export const nameRegex = /^[a-zA-Z-' ]{0,35}$/;
export const passwordRegex = /^(((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&]))|((?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&])))(?=.{8,})(\S+$)/;
export const validateDob = (value, t) => {
    let minDate = parse('01/01/1900', 'P', new Date());
    let maxDate = new Date();
    let inputDate = new Date(value);
    if (!isWithinInterval(inputDate, { start: minDate, end: maxDate })) {
        return t({
            english: `Date is not between 01/01/1900 and ${GetCurrentDate()}`,
            spanish: `La fecha no está entre 01/01/1900 y ${GetCurrentDate()}`,
        });
    }
};
export const validateDateStartOfTomorrow = (value, t, dateOfHire, required) => {
    let minDate = dateOfHire ? parse(dateOfHire, 'P', new Date()) : parse('01/01/1900', 'P', new Date());
    let maxDate = new Date(startOfTomorrow());
    let inputDate = new Date(value);
    if (!isWithinInterval(inputDate, { start: minDate, end: maxDate }) && required) {
        return t({
            english: `Date is not between 01/01/1900 and ${format(startOfTomorrow(), 'MM/dd/yyyy')}`,
            spanish: `La fecha no está entre 01/01/1900 y ${format(startOfTomorrow(), 'MM/dd/yyyy')}`,
        });
    }
};
export function isNotEmpty(input) {
    return !!input;
}
export function isValidUsername(value) {
    if (!value) {
        return true;
    }
    return usernameRegex.test(value);
}
export function phoneIsNotBlacklisted(value) {
    const blacklist = [
        '93',
        '375',
        '243',
        '236',
        '225',
        '86',
        '53',
        '964',
        '98',
        '850',
        '961',
        '231',
        '218',
        '95',
        '234',
        '40',
        '7',
        '252',
        '211',
        '963',
        '380',
        '967',
        '263',
    ];
    if (value == null) {
        return true;
    }
    else {
        const formattedPhoneNumber = value.replace(/-/g, '').replace(/ /g, '');
        const parsedPhoneNumber = parsePhoneNumberFromString(formattedPhoneNumber);
        const countryCode = formattedPhoneNumber && formattedPhoneNumber.length > 10 && parsedPhoneNumber
            ? parsedPhoneNumber.countryCallingCode
            : '1';
        for (const blacklistedCode of blacklist) {
            if (blacklistedCode === countryCode) {
                return false;
            }
        }
        return true;
    }
}
export function isValidPhoneNumber(value) {
    if (!value) {
        return true;
    }
    else {
        const phoneNumberDigits = value.replaceAll(/\D/g, '');
        //Libphonenumber cannot parse a non us country code without the leading '+'
        const parserValue = phoneNumberDigits.length == 10 ? phoneNumberDigits : "+" + phoneNumberDigits;
        const parsedPhoneNumber = parsePhoneNumberFromString(parserValue, 'US');
        const isValidParsed = !!parsedPhoneNumber?.isValid();
        const isValidLength = phoneNumberDigits.length >= 10 && phoneNumberDigits.length < 15;
        return isValidParsed && isValidLength;
    }
}
export function isValidEmail(email) {
    if (!email) {
        return true;
    }
    return emailPattern.test(email) && email.length < 140;
}
export function isValidName(value) {
    if (!value) {
        return true;
    }
    return nameRegex.test(value);
}
export function isPasswordFormatValid(value, values) {
    if (!value) {
        return true;
    }
    return passwordRegex.test(value);
}
export function isPasswordSecure(password, values) {
    if (!password || !values) {
        return true;
    }
    return password !== values.username;
}
export function isValidReEnteredPassword(reEnteredPassword, values) {
    if (!reEnteredPassword || !values) {
        return true;
    }
    return reEnteredPassword === values.pwd;
}
